import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularBreadcrumbComponent } from './angular-breadcrumb.component';


@NgModule({
    imports: [CommonModule],
    declarations: [AngularBreadcrumbComponent],
    exports: [AngularBreadcrumbComponent],
    providers: []
})
export class AngularBreadcrumbModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/breadcrumb/angular-breadcrumb.module.ts